module.exports = __webpack_public_path__ + "img/ic_chevron_right_blue.250d5e3a.svg";